import { networkSignal } from "@/utils/signals";
import { initApi } from "@/utils";

import { PortfolioDocument } from "../models";

export function usePortfolioDocMutation() {
  const api = initApi();
  const portfolioDocsMutation = networkSignal<PortfolioDocument>({ retry: { delayMs: 1000, maxAttempts: 3 } });
  const deleteMutation = networkSignal<void>({ retry: { delayMs: 1000, maxAttempts: 3 } });
  const editMutation = networkSignal<void>({ retry: { delayMs: 1000, maxAttempts: 3 } });

  const addDocument = async (document: PortfolioDocument) => {
    return await portfolioDocsMutation.run(async () => {
      return await api.createPortfolioDocument({ portfolioDocument: document });
    });
  };

  const deleteDocument = async (documentId: string) => {
    return await deleteMutation.run(async () => {
      await api.deletePortfolioDocument({ documentId });
    });
  };

  const editDocument = async (document: PortfolioDocument) => {
    return await portfolioDocsMutation.run(async () => {
      if (!document.id) {
        throw new Error("Document id is required to edit a document");
      }

      return await api.updatePortfolioDocument({ documentId: document.id, portfolioDocument: document });
    });
  };

  return {
    add: { mutate: addDocument, ...portfolioDocsMutation.signal },
    delete: { mutate: deleteDocument, ...deleteMutation.signal },
    edit: { mutate: editDocument, ...editMutation.signal },
  };
}
